<template>
    <div class="form">
        <ValidationObserver ref="form">
            <PersonalDetailsForm
                :user="app_user"
                @data-changed="updateForm"
            >
            </PersonalDetailsForm>

            <div class="row">
                <div class="col-12 text-right ">
                    <div class="wrap-border-top">
                        <a
                            href="javascript:void(0)"
                            class="btn btn--secondary w-100 w-sm-auto"
                            @click="save"
                        >
                            Continue
                        </a>
                    </div>
                </div>
            </div>
        </ValidationObserver>

    </div>
</template>

<script>
import PersonalDetailsForm from "../CommonForms/PersonalDetailsForm.vue";
import ApplicationFormService from "../services/ApplicationFormService";


export default {
    name: "ApplicantFormStep1",
    components: {
        PersonalDetailsForm
    },
    props: {
        app_user: Object,
    },
    data() {
        return {
            dataFormStep1: {}
        }
    },

    methods: {
        save() {
            (async () => {
                const valid = await this.$refs.form.validate();

                if (!valid) {
                    this.$showValidationErrorMessage();
                    return;
                }
                try {
                    const response = await ApplicationFormService.saveStep1(this.dataFormStep1);
                    if (response.status === 200) {
                        this.$showSuccessMessage();
                        setTimeout(() => {
                            window.location.href = '/application-step-2';
                        }, 1000)
                    }
                } catch (error) {
                    this.$handleErrors(error)
                }
            })();
        },

        updateForm(dataPersonalDetails) {
            this.dataFormStep1 = dataPersonalDetails
        },
    },

}
</script>


<style scoped>

</style>
